import React from 'react';

import JobsListPage from '../../../js/pages/JobsListPage';
import ib from '../../../js/pages/JobsListPage/ibJobs';

const Page = () => <JobsListPage role={ib} />;

export default Page;
